/**
 * Boot — first scene; configures scaling and hands off to Preload.
 *
 * Reads the manifest's `orientation` field to lock the Scale Manager into
 * a sensible mode and seeds the global registry with shared SDK objects
 * (manifest, audio, input, i18n, network, sync, latency, reconnect, storage,
 * fpsMonitor, qualityScaler, telemetry, theme).
 */
import { Theme } from '../ui/Theme.js';

export class Boot extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create() {
    // bootGame() has already constructed Phaser with the right base size and
    // FIT scaling derived from manifest.orientation; nothing more to do here
    // beyond painting the background to match the theme so the canvas doesn't
    // flash white before Preload runs.
    this.cameras.main.setBackgroundColor(Theme.colors.bg);
    this.scene.start('Preload');
  }
}
